import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import './Sidebar.css';

export const Sidebar = ({ categories, activeCategory, onCategoryClick, isMobile }) => {
  return (
    <div className={`sidebar ${isMobile ? 'mobile-sidebar' : 'desktop-sidebar'}`}>
      <div className={`${isMobile ? 'mobile-nav' : 'desktop-nav'}`}>
        {categories.map((category) => (
          <div key={category.id} className={isMobile ? 'mobile-nav-item' : 'desktop-nav-item'}>
            <div
              href={`#${category.name.toLowerCase()}`}
              className={`theme-nine-nav-link d-flex  text-uppercase text-black ${isMobile ? 'mobile-nav-link' : 'desktop-nav-link'} 
                ${activeCategory === category.name.toLowerCase() ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                onCategoryClick(category.name.toLowerCase());
              }}
            >
              {category.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
